import { useNavigate } from 'react-router-dom';

// project imports
import { useAuth } from 'modules/auth/hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentUser) {
            navigate('login', { replace: true });
        }
    }, [currentUser, navigate]);

    return children;
};

export default AuthGuard;
